import { c as _c } from "react/compiler-runtime";
import { SdbCompanyMenuItem } from "@components/sidebar/sdb-company/sdb-company-menu-item";
import { SdbCompanySidebarItem } from "@components/sidebar/sdb-company/sdb-company-sidebar-item";
import { Box } from "@mui-wrapper";
import { sdbCompaniesSelector, selectedSdbCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { Menu, Divider } from "@flat-ui";
import { sortWorkspaces } from "@utils/sdb-company-utils";
import { useState } from "react";

/**
 * Menu to be used in the side panel that when closed only shows the current company name,
 * and when opened shows all the sdbCompanies (workspaces/companies) that the user has access and provide
 * an easy way to switch between them.
 *
 * @returns React sdb company menu component.
 */
export function SdbCompanyMenu() {
  const $ = _c(28);
  const [anchorEl, setAnchorEl] = useState(null);
  const sdbCompanies = useAppSelector(sdbCompaniesSelector);
  const selectedSdbCompany = useAppSelector(selectedSdbCompanySelector);
  const hasManySdbCompanies = sdbCompanies.length > 1;
  const isOpen = Boolean(anchorEl);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function handleClick(event) {
      setAnchorEl(event.currentTarget);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleClick = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handleClose() {
      setAnchorEl(null);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClose = t1;
  let t2;
  if ($[2] !== sdbCompanies || $[3] !== selectedSdbCompany) {
    t2 = function sortSdbCompanies() {
      let sortedSdbCompanies = sdbCompanies.sort(sortWorkspaces);
      if (selectedSdbCompany) {
        sortedSdbCompanies = sortedSdbCompanies.filter(sdbCompany => sdbCompany.id !== selectedSdbCompany.id);
        sortedSdbCompanies.unshift(selectedSdbCompany);
      }
      return sortedSdbCompanies;
    };
    $[2] = sdbCompanies;
    $[3] = selectedSdbCompany;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const sortSdbCompanies = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = event_0 => handleClick(event_0);
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== hasManySdbCompanies || $[7] !== isOpen) {
    t4 = <SdbCompanySidebarItem hasManySdbCompanies={hasManySdbCompanies} isOpen={isOpen} handleClick={t3} />;
    $[6] = hasManySdbCompanies;
    $[7] = isOpen;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = hasManySdbCompanies && isOpen;
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      vertical: "center",
      horizontal: "right"
    };
    t7 = {
      vertical: 24,
      horizontal: "left"
    };
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Box component="div" sx={{
      color: "text.secondary",
      fontSize: "12px",
      paddingTop: "4px",
      paddingBottom: "10px",
      paddingX: "16px",
      userSelect: "none"
    }}>Change workspace</Box>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== hasManySdbCompanies || $[13] !== sortSdbCompanies) {
    let t10;
    if ($[15] !== hasManySdbCompanies) {
      t10 = (sdbCompany_0, index) => <SdbCompanyMenuItem sdbCompany={sdbCompany_0} key={sdbCompany_0.name} shouldShowDivider={index === 0 && hasManySdbCompanies} />;
      $[15] = hasManySdbCompanies;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    t9 = sortSdbCompanies().map(t10);
    $[12] = hasManySdbCompanies;
    $[13] = sortSdbCompanies;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Divider sx={{
      marginTop: "34px",
      marginBottom: "9px"
    }} />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Box component="a" href="/" sx={{
      paddingX: "15px",
      textDecoration: "none",
      fontSize: "12px",
      color: "primary.main",
      "&:hover": {
        cursor: "pointer",
        textDecoration: "none"
      }
    }}>Browse All</Box>;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t9) {
    t12 = <Box component="div" data-testid="SIDEBAR_WORKSPACE_LIST">{t9}{t10}{t11}</Box>;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== anchorEl || $[22] !== t12 || $[23] !== t5) {
    t13 = <Menu minWidth="unset" aria-labelledby="workspaces-menu-btn" anchorEl={anchorEl} open={t5} onClose={handleClose} anchorOrigin={t6} transformOrigin={t7}>{t8}{t12}</Menu>;
    $[21] = anchorEl;
    $[22] = t12;
    $[23] = t5;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13 || $[26] !== t4) {
    t14 = <>{t4}{t13}</>;
    $[25] = t13;
    $[26] = t4;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
}